import { TournamentInvitationWithDetails } from '../models';
import { TournamentInvitationRepository } from '../repositories/TournamentInvitationRepository';
import { logger } from '@/src/core/utils';

export class GetInvitationsSentUseCase {
  constructor(private invitationRepository: TournamentInvitationRepository) {}

  async execute(
    userId: string,
    limit: number = 20,
    offset: number = 0
  ): Promise<TournamentInvitationWithDetails[]> {
    logger.debug('GetInvitationsSent', 'Loading sent invitations', { userId });
    return this.invitationRepository.getSent(userId, limit, offset);
  }
}
